import { Controller } from "@hotwired/stimulus"

// Uploads a brand guideline slide to the analyze endpoint and pre-fills the
// preset form (name, background colour, framing margins) from the AI result.
// Everything stays editable afterwards.
export default class extends Controller {
  static targets = ["file", "button", "status", "colorPicker"]
  static values = { url: String }

  async analyze() {
    const file = this.hasFileTarget && this.fileTarget.files[0]
    if (!file) {
      this.setStatus("Choose a slide image first.", "error")
      return
    }

    this.buttonTarget.disabled = true
    this.setStatus("Analyzing slide…", "muted")

    const body = new FormData()
    body.append("guideline_slide", file)

    try {
      const res = await fetch(this.urlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": this.csrfToken(), Accept: "application/json" },
        body
      })
      const json = await res.json().catch(() => ({}))
      if (!res.ok) {
        this.setStatus(json.error || "Analysis failed.", "error")
        return
      }
      this.fill(json)
      this.setStatus("Pre-filled — review and adjust.", "ok")
    } catch (e) {
      this.setStatus("Network error during analysis.", "error")
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  fill(data) {
    const name = this.field("preset_name")
    if (name && !name.value.trim() && data.suggested_name) name.value = data.suggested_name

    if (data.background_color) {
      const bg = this.field("preset_background_color")
      if (bg) bg.value = data.background_color
      if (this.hasColorPickerTarget) this.colorPickerTarget.value = data.background_color
    }

    ;["margin_top", "margin_bottom", "margin_left", "margin_right"].forEach((key) => {
      if (data[key] !== null && data[key] !== undefined && data[key] !== "") {
        const el = this.field("preset_" + key)
        if (el) el.value = data[key]
      }
    })
  }

  field(id) {
    return this.element.querySelector("#" + id)
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute("content") : ""
  }

  setStatus(message, kind) {
    if (!this.hasStatusTarget) return
    const colors = { error: "var(--piktiz-orange)", ok: "var(--piktiz-green)", muted: "var(--piktiz-gray-500)" }
    this.statusTarget.textContent = message
    this.statusTarget.style.color = colors[kind] || ""
  }
}
